/**
 * Per-browser conveniences in localStorage — a remembered choice, a last view. Storage can be
 * blocked (a private window, site data off) and then throws: reads give null and writes are
 * dropped, so a page never fails on what it merely remembers.
 */

/** The stored text, or null when there is none or storage is blocked. */
export function readStored(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** The stored JSON, parsed — null when there is none, it is not JSON, or storage is blocked. */
export function readStoredJson(key: string): unknown {
  const text = readStored(key);
  if (text === null) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

/** Stores a string as it is, anything else as JSON; dropped when storage is blocked. */
export function writeStored(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
  } catch {
    // Blocked storage: nothing is remembered.
  }
}
